import { ArrowRight, Info } from "lucide-react";
import React from "react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ScaledThumbnail } from "./ScaledThumbnail";

interface RecurringTransactionsCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

const COMMITMENTS = [
  {
    name: "Office Rent",
    due: "Today",
    date: "11 Aug 2026 · monthly",
    amount: "£12,500.00",
    intent: "error",
  },
  {
    name: "Payroll",
    due: "5d",
    date: "16 Aug 2026 · monthly",
    amount: "£85,000.00",
    intent: "warning",
  },
  {
    name: "Client Retainer",
    due: "12d",
    date: "23 Aug 2026 · monthly",
    amount: "£25,000.00",
    intent: "success",
  },
  {
    name: "Software Licences",
    due: "21d",
    date: "1 Sep 2026 · monthly",
    amount: "Variable",
    intent: "success",
  },
];

export function RecurringTransactionsCardThumbnail({
  isHovered = false,
  alwaysVisible = false,
}: RecurringTransactionsCardThumbnailProps) {
  return (
    <ScaledThumbnail
      isHovered={isHovered}
      alwaysVisible={alwaysVisible}
      contentWidth={380}
    >
      <Card className="w-[380px] flex flex-col">
        <CardHeader className="border-b">
          <div className="flex items-center gap-1.5">
            <CardTitle className="text-lg font-semibold text-neutral-900">
              Upcoming Recurring Commitments
            </CardTitle>
            <Info className="h-3.5 w-3.5 text-muted-foreground" />
          </div>
          <CardDescription>
            4 commitments due in the next 30 days
          </CardDescription>
        </CardHeader>
        <CardContent className="p-0">
          <div className="px-6 py-4 space-y-3">
            {COMMITMENTS.map((commitment) => (
              <div
                key={commitment.name}
                className="flex items-center justify-between p-3 border rounded-lg"
              >
                <div className="flex items-center gap-3">
                  <span
                    className="text-xs font-semibold px-2 py-1 rounded-md flex-shrink-0 min-w-[44px] text-center"
                    style={{
                      backgroundColor: `var(--mc-${commitment.intent}-bg)`,
                      color: `var(--mc-${commitment.intent}-icon)`,
                    }}
                  >
                    {commitment.due}
                  </span>
                  <div>
                    <p className="font-medium text-sm">{commitment.name}</p>
                    <p className="text-xs text-muted-foreground">
                      {commitment.date}
                    </p>
                  </div>
                </div>
                <span className="text-sm font-medium tabular-nums text-right">
                  {commitment.amount}
                </span>
              </div>
            ))}
          </div>
          <div className="px-6 py-3 border-t flex justify-end">
            <Button variant="ghost" size="sm" className="text-neutral-900">
              View all recurring commitments
              <ArrowRight className="h-3 w-3 ml-1" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </ScaledThumbnail>
  );
}

export default RecurringTransactionsCardThumbnail;
